import { components, GroupProps } from 'react-select'

import { SelectOption, SelectOptionGroup } from '../types'

export const groupClassName = () => ''

export function CustomGroup<T>(props: GroupProps<SelectOption<T>, false, SelectOptionGroup<T>>) {
    return (
        <>
            <components.Group {...props} />
            <div className="my-2 h-px bg-neutral-selected last:hidden" />
        </>
    )
}
